import { useEffect, useState } from "react";
const getSize = () => {
  const safeAreaInsetTop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-top')) || 0; // Fallback value
  const safeAreaInsetBottom = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-bottom')) || 0; // Fallback value
  const safeAreaInsetLeft = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-left')) || 0;
  const safeAreaInsetRight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-right')) || 0;
  return {
    innerHeight: window.innerHeight,
    innerWidth: window.innerWidth,
    outerHeight: window.outerHeight,
    outerWidth: window.outerWidth,
    safeAreaInsetTop,
    safeAreaInsetBottom,
    safeAreaInsetLeft,
    safeAreaInsetRight
  };
};
export const WindowSizeContextProvider = {};

/**
 * A hook that will return inner and outer height and width values whenever
 * the window is resized.
 *
 * @kind function
 * @private
 */
export function useWindowSize() {
  const MOBILE_SIZE_THRESHOLD = 1120;
  const SMARTPHONE_SIZE_THRESHOLD = 640;

  // Initialize state with the size values and insets
  const [windowSize, setWindowSize] = useState(getSize());
  const [isMobile, setIsMobile] = useState(windowSize.innerWidth < MOBILE_SIZE_THRESHOLD);
  const [isSmartphone, setIsSmartphone] = useState(windowSize.innerWidth < SMARTPHONE_SIZE_THRESHOLD);
  useEffect(() => {
    const handleResize = () => {
      const newSize = getSize();

      // Update the state only if something has changed
      if (newSize.innerWidth !== windowSize.innerWidth || newSize.innerHeight !== windowSize.innerHeight) {
        setWindowSize(newSize);
        setIsMobile(newSize.innerWidth < MOBILE_SIZE_THRESHOLD);
        setIsSmartphone(newSize.innerWidth < SMARTPHONE_SIZE_THRESHOLD);
      }
    };

    // Listen for window resize events
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [windowSize]); // Only run if windowSize changes

  // Return the window size data and additional flags
  return {
    innerWidth: windowSize.innerWidth,
    innerHeight: windowSize.innerHeight,
    outerWidth: windowSize.outerWidth,
    outerHeight: windowSize.outerHeight,
    isMobile,
    isSmartphone,
    safeAreaInsetTop: windowSize.safeAreaInsetTop,
    safeAreaInsetBottom: windowSize.safeAreaInsetBottom,
    safeAreaInsetLeft: windowSize.safeAreaInsetLeft,
    safeAreaInsetRight: windowSize.safeAreaInsetRight
  };
}